import classNames from 'classnames'

import ReportBugIcon from '@app/assets/images/reportBug.svg?react'
import { useTestId } from '@app/hooks/useTestId'
import { useTranslation } from '@app/locales'

type Props = {
  isExpanded: boolean
  onClick: () => void
}

export const BugReportButton = ({ isExpanded, onClick }: Props) => {
  const { t } = useTranslation(['common'])
  const testId = useTestId()

  return (
    <div
      className={classNames(
        'mb-1 flex cursor-pointer items-center rounded bg-primary-800 p-3 transition-colors duration-200 hover:bg-[#FF8AB5]/30',
        isExpanded ? 'h-12 w-full justify-start' : 'inline-table justify-center'
      )}
      onClick={onClick}
      data-testid={testId('side_navigation.bug_report')}
    >
      <ReportBugIcon />

      {isExpanded && <span className="ml-2 text-sm font-medium text-neutral-100">{t('bugReport.button')}</span>}
    </div>
  )
}
